/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateMetaMcpServerForm,
  CreateMetaMcpServerForm$Outbound,
  CreateMetaMcpServerForm$outboundSchema,
} from "../components/createmetamcpserverform.js";

export type CreateMetaMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateMetaMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateMetaMcpServerSecurity = {
  option1?: CreateMetaMcpServerSecurityOption1 | undefined;
  option2?: CreateMetaMcpServerSecurityOption2 | undefined;
};

export type CreateMetaMcpServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createMetaMcpServerForm: CreateMetaMcpServerForm;
};

/** @internal */
export type CreateMetaMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateMetaMcpServerSecurityOption1$outboundSchema: z.ZodMiniType<
  CreateMetaMcpServerSecurityOption1$Outbound,
  CreateMetaMcpServerSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createMetaMcpServerSecurityOption1ToJSON(
  createMetaMcpServerSecurityOption1: CreateMetaMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    CreateMetaMcpServerSecurityOption1$outboundSchema.parse(
      createMetaMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateMetaMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateMetaMcpServerSecurityOption2$outboundSchema: z.ZodMiniType<
  CreateMetaMcpServerSecurityOption2$Outbound,
  CreateMetaMcpServerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function createMetaMcpServerSecurityOption2ToJSON(
  createMetaMcpServerSecurityOption2: CreateMetaMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    CreateMetaMcpServerSecurityOption2$outboundSchema.parse(
      createMetaMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateMetaMcpServerSecurity$Outbound = {
  Option1?: CreateMetaMcpServerSecurityOption1$Outbound | undefined;
  Option2?: CreateMetaMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateMetaMcpServerSecurity$outboundSchema: z.ZodMiniType<
  CreateMetaMcpServerSecurity$Outbound,
  CreateMetaMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateMetaMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateMetaMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createMetaMcpServerSecurityToJSON(
  createMetaMcpServerSecurity: CreateMetaMcpServerSecurity,
): string {
  return JSON.stringify(
    CreateMetaMcpServerSecurity$outboundSchema.parse(
      createMetaMcpServerSecurity,
    ),
  );
}

/** @internal */
export type CreateMetaMcpServerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateMetaMcpServerForm: CreateMetaMcpServerForm$Outbound;
};

/** @internal */
export const CreateMetaMcpServerRequest$outboundSchema: z.ZodMiniType<
  CreateMetaMcpServerRequest$Outbound,
  CreateMetaMcpServerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createMetaMcpServerForm: CreateMetaMcpServerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createMetaMcpServerForm: "CreateMetaMcpServerForm",
    });
  }),
);

export function createMetaMcpServerRequestToJSON(
  createMetaMcpServerRequest: CreateMetaMcpServerRequest,
): string {
  return JSON.stringify(
    CreateMetaMcpServerRequest$outboundSchema.parse(createMetaMcpServerRequest),
  );
}
